import React from "react";
import StarFilledIcon from "../icons/StarFilledIcon";
import StarOutlinedIcon from "../icons/StarOutlinedIcon";
import CloseIcon from "../icons/CloseIcon";
import { TOOLTIP_ID } from "./keywords/Keywords";

interface IProps {
  onDelete: (id: string) => void;
  onClick?: (id: string) => void;
  onTextClick?: (id: string) => void;
  isActive?: boolean;
  showRequiredMark?: boolean;
  chipDetails: {
    text: string;
    id: string;
  };
}

const Chip: React.FC<IProps> = ({
  chipDetails: { text, id },
  onDelete,
  isActive,
  showRequiredMark,
  onClick,
  onTextClick,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick(id);
    }
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete(id);
  };

  const handleTextClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onTextClick) {
      onTextClick(id);
    }
  };
  return (
    <div className="qs_chip">
      {showRequiredMark && (
        <span
          onClick={handleClick}
          className="qs_pointer qs_align_center"
          data-tooltip-id={TOOLTIP_ID}
          data-tooltip-content={
            isActive
              ? "This keyword is marked as 'Mandatory'."
              : "Mark this keyword as 'Mandatory'."
          }
        >
          {isActive ? <StarFilledIcon /> : <StarOutlinedIcon />}
        </span>
      )}

      <span
        onClick={handleTextClick}
        className={onTextClick ? "qs_pointer" : ""}
      >
        {text}
      </span>

      <span onClick={handleDeleteClick} className="qs_pointer qs_chip_rmv">
        <CloseIcon />
      </span>
    </div>
  );
};

export default Chip;
